var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f3 footerLinklist container"},_vm._l((_vm.contentData),function(section){return _c('MenuList',{key:_vm.buildKey(section),attrs:{"menuList":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }